const ArrayUtils = {
    /**
     * If the item is already in the array, removes the item; otherwise, adds the item
     *
     * @param {array} arr The array to be updated
     * @param {string} val The value of the item to either add or remove from array
     * @returns {array} The updated version of the array
     */
    addOrRemoveArrayItem(arr, val) {
        const i = arr.indexOf(val);

        if (i > -1) {
            arr.splice(i, 1);
        } else {
            arr.push(val);
        }

        return arr;
    },

    /**
     * Checks the equality of two individual arrays regardless of order.
     * Note: All values of the arrays must be primitives and not objects.
     *
     * @param {array} arr1 The first array to be compared
     * @param {array} arr2 The second array to be compared
     * @returns {boolean} Whether the two arrays each have the same values
     */
    hasEqualValues(arr1, arr2) {
        if (Array.isArray(arr1) && Array.isArray(arr2)) {
            const sortedArr1 = [...arr1].sort();
            const sortedArr2 = [...arr2].sort();

            return (
                sortedArr1.length === sortedArr2.length && sortedArr1.every((val, index) => val === sortedArr2[index])
            );
        }
        return false;
    },
};

export default ArrayUtils;
